import { useState } from "react";
import { MessageCircleQuestion } from "lucide-react";
import { fetchFollowup } from "@/lib/api";
import { useAsync } from "@/lib/hooks";
import { ErrorBox, Spinner } from "@/components/lf";

export default function FollowUp({ type, contextText }) {
  const [q, setQ] = useState("");
  const [answer, setAnswer] = useState("");
  const [st, run] = useAsync();
  const ask = async (e) => {
    e.preventDefault();
    if (q.trim().length < 3) return;
    const r = await run(() => fetchFollowup({ context_type: type, context_text: contextText.slice(0, 3900), question: q.trim() }));
    if (r) setAnswer(r.jawaban);
  };
  return (
    <div className="border-t border-[#29292D] pt-5 mt-6" data-testid="followup-section">
      <div className="lf-overline flex items-center gap-2 mb-3"><MessageCircleQuestion size={13} />Pertanyaan lanjutan</div>
      <form onSubmit={ask} className="flex flex-col sm:flex-row gap-2">
        <input data-testid="followup-input" value={q} onChange={(e) => setQ(e.target.value)} maxLength={800} placeholder="Tanyakan sesuatu tentang hasil ini…" className="lf-field flex-1" />
        <button data-testid="followup-submit" disabled={st.loading || q.trim().length < 3} className="lf-btn">{st.loading ? <Spinner label="Berpikir…" /> : "Lanjutkan bertanya"}</button>
      </form>
      <div className="mt-3"><ErrorBox error={st.error} testid="followup-error" /></div>
      {answer && <div data-testid="followup-answer" className="mt-3 text-sm leading-relaxed text-[#F2F0EC] bg-[#1B1B1F] border border-[#29292D] rounded-sm p-4 whitespace-pre-wrap">{answer}</div>}
    </div>
  );
}
